import { OrderExtraCost } from "./enquiry.model";
import { ExtraCost } from "./extraCostParametersValues.model";

export class CalculateMarginsAndPricesPayload {
    changedField?: 'ActualFm' | 'ActualFmAmountPerWeight' | 'NegotiationMargin' | 'AgentFee' | 'FinalPrice' | 'ItemExtraCosts';
    itemPrice?: ItemPrice
    previousFinalPrice?: number;
}

export class ItemPrice {
    actualFm?: number;
    actualFmAmountPerWeight?: number;
    negotiationMargin?: number;
    agentFee?: number;
    finalPrice?: number
    itemExtraCosts?: ExtraCost[];
    orderExtraCost?: OrderExtraCost
}